// extracted by mini-css-extract-plugin
module.exports = {"button":"ArchiveButton_button__12nnc","icon":"ArchiveButton_icon__3lE2x"};